<script>

  import { onMount } from 'svelte';
  import { External, M } from '../../external';
  import { makeLmsRequest } from '../service/LmsClient';
  import Loader from '../../Common/Loader.svelte';
  import { LmsCircleUtils } from './LmsCircleUtils';
  import { addNewCircle } from '../service/LmsUIService';
  import { showActivateAddonUI } from '../../Billing/Addons/addons';

  let loading = true;
  let circles = [];

  let goToCircle = (circle) => {
    External.CPanel.goToUrl('/me/community/circles/' + circle.url);
  };

  let setPublished = async (circle) => {
    let message = circle.published ? M.UNPUBLISH_CIRCLE_QUESTION : M.PUBLISH_CIRCLE_QUESTION;
    External.Tools.prompt('', message, async () => {
      await LmsCircleUtils.togglePublished(circle);
      circles = circles;
    });
  };

  let onSettingsAction = async (action, circle) => {
    switch (action) {
      case 'delete':
        External.Tools.prompt('', M.DELETE_CIRCLE_QUESTION, async () => {
          await LmsCircleUtils.deleteCircle(circle);
          circles = circles.filter(c => c.id !== circle.id);
        });
        break;
      case 'duplicate':
        External.Tools.prompt('', M.CLONE_CIRCLE_QUESTION, async () => {
          let newCircle = await LmsCircleUtils.duplicateCircle(circle.url);
          if (newCircle) {
            External.CPanel.goToUrl('/me/community/circles/' + newCircle.url);
          }
        });
        break;
      case 'preview':
        LmsCircleUtils.preview(circle);
        break;
      case 'copy-link':
        LmsCircleUtils.copyCircleUrl(circle);
        break;
      case 'publish-unpublish':
        await setPublished(circle);
        break;
    }
  };

  let onSettingsClicked = (event, circle) => {
    const target = External.$(event.target);
    let items = [
      { text: M.DUPLICATE, icon: 'fa-clone', tag: 'duplicate' },
      { text: M.PREVIEW, icon: 'fa-eye', tag: 'preview' },
      { text: M.COPY_LINK_CAPITALIZED, icon: 'fa-link', tag: 'copy-link' },
      { text: circle.published ? M.UNPUBLISH_CIRCLE : M.PUBLISH, icon: 'fa-eye-slash', tag: 'publish-unpublish' },
      { text: M.DELETE, icon: 'fa-trash', tag: 'delete' }
    ];

    External.Tools.showTooltipOptions(target, items, function(target, idx, text, tag) {
      onSettingsAction(tag, circle);
    });
  };

  let showAnalytics = async (circle) => {
    LmsCircleUtils.showAnalytics(circle.url);
  };

  let showAddonPopup = async () => {
    await showActivateAddonUI('COMMUNITY', null, true, M.COMMUNITY_LIMITS_REACHED);
    setTimeout(() => {
      External.Website.communityLimitReached = External.Website.communityLimitReached;
    }, 1000)
  }

  onMount(async () => {
    loading = true;
    let result = await makeLmsRequest('/circle/all', 'GET');
    circles = result.ok ? await result.json() : [];
    loading = false;
  });
</script>

<div class="account-settings overflow store-products flex-1 col20" style="font-family: 'Roboto';">


  <div class="top-background-wrapper narrow-top-background">
    <div class="top-background">
      <div class="text-wrapper f-left col20 flex align-center space-between">
        <div class="flex-centered flex-col-mobile f-left flex" style="display: flex;">
          <h2 class="crm-title f-left crm-title-bigger hide-mobile">{M.CIRCLES} <i class="fa fa-circle"></i></h2>
          <h2 class="crm-title f-left crm-title-bigger">{circles.length} {circles.length === 1 ? M.CIRCLE : M.CIRCLES}</h2>
          <a on:click={addNewCircle}
             class="f-left middle-button rounded-effect with-icon ml-25 blue"
             style="height:39px; line-height:39px;">{M.ADD_CIRCLE}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="content-wrapper horizontal-flex-table">
    <div class="sections-wrapper members-wrapper horizontal-flex-table">
      <div class="sections-wrapper profile-inner-wrapper bg-white box-shadow padding-45 f-left col20">

        {#if External.Website.communityLimitReached}
          <div class="limit-warning-line flex align-center col20 mb-10 cursor-pointer" on:click={showAddonPopup}>
            <span class="material-icons flex-none">error</span>
            <div class="flex-1">
              <h4 class="col20 f-left mb-10">{M.COMMUNITY_LIMIT_TITLE}</h4>
              <span class="col20 f-left">{M.COMMUNITY_LIMIT_DESC}</span>
            </div>
          </div>
        {/if}
        {#if loading}
          <Loader compact={true} />
        {:else}
          {#if circles.length === 0}
            <div class="no-data-image col20 f-left mb-35">
              <span class="material-icons-outlined"> group_work </span>
              <h3 class="col20 f-left t-center mt-25">{M.NO_CIRCLES}</h3>
              <div class="col20 f-left t-center mt-25">
                <a on:click={addNewCircle} class="middle-button blue with-icon inline-block f-none">{M.CREATE_YOUR_FIRST_CIRCLE}</a>
              </div>
            </div>
          {/if}
          {#each circles as circle(circle.id)}
            <div class="list-circle-wrapper col20 f-left flex align-center space-between" on:click={() => goToCircle(circle)}>
              <div class="flex align-center">
                <div class="list-circle-profile">
                  <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 0 24 24" width="40px" fill="#5f6368">
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6m0-2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z" />
                  </svg>
                </div>
                <div class="list-circle-header">
                  <h4 class="list-circle-name col20 f-left">{circle.name}</h4>
                  <span class="list-circle-members f-left"><b>{circle.members}</b> {circle.members === 1 ? M.MEMBER : M.MEMBERS}</span>
                </div>
              </div>
              <div class="list-circle-controls flex-none flex align-center">
                <a on:click|stopPropagation={() => setPublished(circle)} class="order-status mr-10 f-left" class:completed={circle.published}
                   class:pending={!circle.published}>
                  {circle.published ? M.PUBLISHED : M.NOT_PUBLISHED}
                </a>
                <a class="f-left mr-5 circle-button-small rounded-effect" on:click|stopPropagation={() => showAnalytics(circle)}><span
                  class="material-icons-outlined">analytics</span></a>
                <a class="f-left circle-button-small rounded-effect" on:click|stopPropagation={(event) => {onSettingsClicked(event, circle)}}><span
                  class="material-icons-outlined">settings</span></a>
              </div>
            </div>
          {/each}
        {/if}
      </div>
    </div>
  </div>
</div>
